$(function() {

  $('#video_vol').click(function() {
    $('#video_vol').toggleClass('fa-volume-low');
    $('#video_vol').toggleClass('fa-volume-xmark');
    if ($(this).siblings('video').prop('muted') == true) {
      if (firstUm) {
        // $("#hero_video")[0].pause();
        // $("#hero_video")[0].currentTime = 0;
        $(this).siblings('video').prop('muted', false);
        $(this).siblings('video')[0].play();
        firstUm = false;
      } else {
        $(this).siblings('video').prop('muted', false);  
        $(this).siblings('video')[0].play();
      }
    } else {
      $(this).siblings('video').prop('muted', true);
      $(this).siblings('video')[0].play();
    }
  });

  $('#video_fs').click(function() {
    openFullscreen($('.video-fullscreen video')[0]);
  });

  $('.size-button').click(function() {
    setTimeout(function() {
      $('#cart-notification').removeClass('active');
    }, 4000);
  });

  // TIME DATA
  var today = new Date();
  var date = (today.getMonth()+1)+'/<b>'+today.getDate()+'</b>/'+today.getFullYear().toString().substr(-2);
  let am_pm = today.toLocaleTimeString("en-US", {timeZone: "America/Chicago"});
  var time = today.getHours() + ":" + today.getMinutes();
  $('#chicago-info div:first-of-type').append('<p id="datentime"><b>Chicago</b>&nbsp;—&nbsp;' + am_pm + '</p>');
  $('#chicago-info-mob div:nth-of-type(2)').append('<p id="datentime-mob">' + am_pm + '</p>');

  setInterval(function() {
    today = new Date();
    let am_pm = today.toLocaleTimeString("en-US", {timeZone: "America/Chicago"});
    $('#datentime').html('<b>Chicago</b>&nbsp;—&nbsp;' + am_pm );
    $('#datentime-mob').html( am_pm );
  }, 1000);
  
  // WEATHER DATA
  // $.ajax({
  //   method: "GET",
  //   url: "https://api.openweathermap.org/data/3.0/onecall?lat=41.87&lon=-87.62&units=imperial&appid=1a1312be348fef9f569fbac164d1aef8",
  //   dataType: 'jsonp',
  //   crossDomain: true
  // }).done(function( wea ) {
  //   console.log( wea );
  //   var fnht = wea.current.temp;
  //   var celsius = (fnht - 32) * 5/9;
    
  //   $('#chicago-info div:last-of-type').html('<p>' + wea.current.temp.toString().substr(0,2) + '° F / ' + celsius.toString().substr(0,2) + '° C</p>');
  //   $('#chicago-info-mob div:last-of-type').html('<p>' + wea.current.temp.toString().substr(0,2) + '° F / ' + celsius.toString().substr(0,2) + '° C</p>');
    
  // });

  // $('#Details-menu-drawer-container .header__icon .icon-hamburger').click(function() {
  //   anime({
  //     targets: '.menu-drawer__navigation ul li',
  //     translateX: 300,
  //     direction: 'normal',
  //     loop: false,
  //     duration: 1000,
  //     delay: function(el, i, l) {
  //       return i * 100;
  //     },
  //     endDelay: function(el, i, l) {
  //       return (l - i) * 100;
  //     }
  //   });
  // });

  $('#Details-menu-drawer-container .header__icon .icon-close').click(function() {
    $('.menu-drawer__navigation ul li').attr('style', '');
  });

  $('.tl-project .p_d_expand').click(function() {
    $('.p_d_expand').removeClass("expanded");
    $(this).addClass("expanded");
    $('.p_d_content').removeClass("expanded");
    $(this).siblings('.p_d_content').addClass("expanded");    
  });

  $('.product .p_d_expand').click(function() {
    $(this).toggleClass("expanded");
    $('.product__description').toggleClass("expanded");    
  });

  $('.product__info-container .p_o_expand').click(function() {
    $(this).toggleClass("expanded");
    $('.p_o_content').toggleClass("expanded");    
  });

  console.log(window.location.href);
  
  if (window.location.href == "https://joefreshgoods.com/" || window.location.href == "https://563s7xn4phzr1svx-7139590197.shopifypreview.com/" || window.location.href.indexOf("https://joefreshgoods.com/?") > -1) {
    $('body').addClass('home');
    if (Modernizr.touchevents) {
      $('.dynamic-hero .dbg').each(function() {
        console.log($(this).data('mobile'));
        $(this).css({
          background: 'url('+$(this).data('mobile')+') no-repeat center' 
        });
      });
        
    }
  }

  if (window.location.href == 'https://joefreshgoods.com/collections/shop') {
    $('body').addClass('main-shop');
  }

  if (window.location.href == 'https://joefreshgoods.com/collections/shop-collections') {
    $('body').addClass('shop-colls');
  }

  if (window.location.href == 'https://joefreshgoods.com/collections/all') {
    window.location.href = 'https://joefreshgoods.com/';

  }
    
  if (window.location.href.indexOf('/products/') > -1) {

    $('.p_o_expand').addClass('expanded');
    $('.p_o_content').addClass('expanded');

    $('.thumbnail-list li').click(function() {
      var which_thumb = $('.thumbnail-list li').index($(this));
      var which_media = $('.product__media-list li').eq(which_thumb);

      console.log($(which_media));
      $('body').scrollTo($(which_media).offset().top - 150, 750);
    });


    $(window).scroll(function() {
      $medias = $('.product__media-list li');
      $medias.inViewport().each(function() {
        var which_media = $('.product__media-list li').index($(this));
        var which_thumb = $('.thumbnail-list li').eq(which_media);
        $('.thumbnail-list li').find('button').removeAttr('aria-current');
        $(which_thumb).find('button').attr('aria-current', true);
        $('.thumnail-list').scrollTo($(which_thumb));
      });
    });
    
    $('.product-form__submit').click(function() {
      $('.p_o_content').removeClass('expanded');
    });
  }

  if (window.location.href.indexOf('/pages/projects') > -1) {
    $('body').addClass('projects-page');
  }

  if (window.location.href.indexOf('movies') > -1) {
    $('body').addClass('movies-page');
    
    $('.movie').click(function() {
      $('#movies-popup video').attr('src', $(this).find('video').attr('src'));
      $('#movies-popup').fadeIn();
      $('#movie-box video').prop('muted', false);
      $('#movies-popup i.volume').toggleClass('fa-volume-high');
      $('#movies-popup i.volume').toggleClass('fa-volume-xmark');
    });
    
    $('#movies-popup i.fa-close').click(function() {
      $('#movies-popup').fadeOut();
      $('#movie-box video').prop('muted', true);
      if ($('#movies-popup i.volume').hasClass('fa-volume-high')) {
        $('#movies-popup i.volume').toggleClass('fa-volume-high');
        $('#movies-popup i.volume').toggleClass('fa-volume-xmark');
      }
    });

    $('#movies-popup i.volume').click(function() {
      if ($(this).hasClass('fa-volume-xmark')) {
        $('#movie-box video').prop('muted', false);
      } else {
        $('#movie-box video').prop('muted', true);       
      }
      $(this).toggleClass('fa-volume-high');
      $(this).toggleClass('fa-volume-xmark');

      
      
    });
  }


  if (window.location.href.indexOf('community-goods') > -1) {
    $('body').addClass('cg-page');
  }

  

  if (window.location.href.indexOf('archive') > -1 || window.location.href.indexOf("https://joefreshgoods.com/pages/archive/?") > -1) {
    $('body').addClass('archive');

    $('.ad').each(function() {
      var p_title = $(this).find('.p_title');
      if ( p_title.text().indexOf('“') > -1 ) {
        var p_title_a = p_title.text().split('“');      
        var p_title_temp = p_title_a[0] + '<span style="margin-right: 5px;">“</span>' + p_title_a[1];
        // <span style="font-size: 24pt;">“</span>
        // console.log(p_title_temp);
        
        $(p_title).find('a').html(p_title_temp);
        
        p_title_a = p_title.html().trim().split('”');      
        
        p_title_temp = p_title_a[0] + '<span style="margin-left: 5px;">”</span>' + p_title_a[1];
        console.log(p_title_temp);
        $(p_title).find('a').html(p_title_temp);
        
      }

      
      var adtext = $(this).find('.p_desc').text();
      var adt_l = adtext.length;
      if (adt_l < 100) {
        $(this).find('.p_desc').addClass('short');
      }
    });

    $(window).scroll(function() {
      if (Modernizr.touchevents) {
        if ($(window).scrollTop() > 250) {
          $('.archive-banner').fadeIn();
        } else {
          $('.archive-banner').fadeOut();
        }
      }
    });

    // $('.banner__media').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: false,
    //   dots: false,
    //   autoplay: true,
    //   infinite: true,
    //   fade: true
    // });
    
    // $('body').data('scroll-container', ' ');
  }

  if (window.location.href.indexOf('contact') > -1) {

    if (window.location.href.indexOf('contact?contact_posted=true') > -1) {
      $('body').addClass('contact-page');
      $('.iqfs').fadeOut();
      $('.contact').fadeIn();
    } else {
      $('body').addClass('contact-page');
      $('.iqfs-buttons div').click(function(e) {
        e.preventDefault();
        console.log($(this).index());
        if ($(this).index() == 0) {
          $('.shopify-app-block:first-of-type').fadeIn();
        }
        if ($(this).index() == 1) {
          // $('.shopify-app-block:last-of-type').fadeIn();
          $('.contact').fadeIn();
        }
        $('.iqfs').fadeOut();
      });
    }
    
  }

  if (window.location.href.indexOf('/pages/aged-well') > -1) {
    $('body').addClass('raffle');
  }
  
  if (window.location.href.indexOf('/pages/raffle') > -1) {
    $('body').addClass('raffle');
    if (Modernizr.touchevents) {
      $('.sd span').text('Tap to Scroll');
    }
  
    setTimeout(function() {
      $('.sd').fadeIn(500);  
      
      $('.sd').click(function(e) {
        e.preventDefault();
        var rbb = $(this).find('a').attr('href');
        if (Modernizr.touchevents) {
          $('body').scrollTo(rbb, 700);
        } else {
          $('body').scrollTo(rbb, 800);
        }
      });
  
    }, 1500);
    
    var vid =  $("#hero_video")[0];
    var firstUm = true;
    
    

    if ($("#hero_video").length > 0) {
      $("#hero_video")[0].addEventListener('webkitendfullscreen', function (e) { 
        setTimeout(function() {
          $("#hero_video")[0].play();
        }, 500);
      });
    }

   // $('.raffle-options').slick({
   //    infinite: false,
   //    slidesToShow: 2,
   //    slidesToScroll: 1,
   //    arrows: false,
   //    responsive: [
   //      {
   //        breakpoint: 1024,
   //        settings: {
   //          slidesToShow: 2,
   //          slidesToScroll: 2,
   //          infinite: true,
   //          dots: true
   //        }
   //      },
   //      {
   //        breakpoint: 600,
   //        settings: {
   //          slidesToShow: 2,
   //          slidesToScroll: 2
   //        }
   //      },
   //      {
   //        breakpoint: 480,
   //        settings: {
   //          slidesToShow: 1,
   //          slidesToScroll: 1
   //        }
   //      }
   //    ]
   //  });
  
  }

  function openFullscreen(myVideo) {
    var elem = myVideo;
    if (elem.webkitEnterFullScreen) {
        // Toggle fullscreen in Safari for iPad
        elem.webkitEnterFullScreen();
    } else {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    }
  }


  window.onscroll = function() {showProgress()};
  function showProgress() {
     var scrollCalculate = document.body.scrollTop || document.documentElement.scrollTop;
     var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
     var scrolled = (scrollCalculate / height) * 100;
  document.querySelector(".progressBar").style.height = scrolled + "%";
  }

  
  
});

$(window).on('load', function() {

  if (window.location.href.indexOf('archive') > -1) {
    var scroll = new LocomotiveScroll({
      el: document.querySelector('[data-scroll-container]'),
      smooth: true
    });
  }
});